<script setup>
import request from '@/utils/request'
import { ref, reactive } from 'vue'
import { formatNumber } from '@/utils/number.js'
import { isMoible } from '@/utils/common.js'

if (isMoible()) {
  window.location.href = 'https://static.medsci.cn/product/medsci/active/hot/index.html#/hot_title_m'
}

// 获取新闻列表
const newsList = reactive([])
const getNewsList = async () => {
  const { data } = await request.get('/activity/hotList')
  data.length = 10
  newsList.value = data
}
getNewsList()

// 悬浮窗
const showQrcode = ref(false)

// 返回顶部
function scrollTop () {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
}
</script>
<template>
  <div class="container">
    <nav>
      <a href="https://www.medsci.cn/">
        <img class="logo" src="https://static.medsci.cn/public-image/ms-image/3f40d210-69e6-11ec-8e2f-1389d01aad85_logo.png" />
      </a>
      <ul>
        <li><a href="https://www.medsci.cn/">热点资讯</a></li>
        <li><a href="https://www.medsci.cn/sci/index.do">期刊专题</a></li>
        <li><a href="https://www.medsci.cn/sci/nsfc.do">国自然基金</a></li>
      </ul>
      <a class="aDownloadApp" href="https://a.app.qq.com/o/simple.jsp?pkgname=cn.medsci.app.news">下载APP</a>
    </nav>
    <div class="slogan">
      <img src='https://static.medsci.cn/public-image/ms-image/07610250-69e8-11ec-8e2f-1389d01aad85_slogan.png'/>
    </div>
    <!-- 主要内容 -->
    <main>
      <div class="item" v-for="item in newsList.value" :key="item.id">
        <a :href="'https://www.medsci.cn/article/show_article.do?id=' + item.id">
          <div>
            <p>
              {{ item.title }}
            </p>
            <div class="info">
              <span class="date">{{ item.publishedTime }}</span>
              <span class="hits">
                <img src="https://static.medsci.cn/public-image/ms-image/5218f970-687a-11ec-8e2f-1389d01aad85_fire.png" />
                {{ formatNumber(item.allHits) }}
              </span>
            </div>
          </div>
          <img class="cover" :src="item.cover" />
        </a>
      </div>
    </main>
    <section class="float_window">
      <ul>
        <li @mouseover="showQrcode = true" @mouseleave="showQrcode = false">
          <img
            src="https://static.medsci.cn/public-image/ms-image/e7a3b860-69e0-11ec-8e2f-1389d01aad85_icon_1.png"
            style="width: 24.88px; height: 25.13px"
          />
          <p>分享</p>
        </li>
        <li>
          <a href="https://a.app.qq.com/o/simple.jsp?pkgname=cn.medsci.app.news">
            <img
              src="https://static.medsci.cn/public-image/ms-image/e7a3b860-69e0-11ec-8e2f-1389d01aad85_icon_2.png"
              style="width: 19px; height: 28px;margin-top:13px;"
            />
            <p>APP下载</p>
          </a>
        </li>
        <li @click="scrollTop">
          <img
            src="https://static.medsci.cn/public-image/ms-image/e7a3b860-69e0-11ec-8e2f-1389d01aad85_icon_3.png"
            style="width: 24px; height: 24px;margin-top:13px;"
          />
          <p>返回顶部</p>
        </li>
      </ul>
      <div class="qrcode" v-show="showQrcode">
        <img src="https://www.medsci.cn/v1.0.0/img/medsci_wechat.png" style="width: 109px; height: 109px" />
      </div>
    </section>
  </div>
</template>
<style lang="less" scoped>
@import url('index.less');
</style>
